// Load plugins
var $ = require('jquery');
import axios from 'axios'
import helper from './helper'
import moment from 'moment'
import 'moment/min/locales'
moment.locale('es');
// Set plugins globally
window._ = require('lodash');
window.$ = window.jQuery = $;
window.moment = moment;
window.axios = axios;
window.helper = helper;
window.Vue = require('vue');

// CSRF token
let token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}
